// data
const customer = () => ({});
const detailCustomer = () => ({});
const alamat = () => ({});
const topFive = () => ({});
const riwayat = () => ({});

// filter
const pagination = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const paginationAlamat = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const search = () => ({
	key: "",
});
const searchAlamat = () => ({
	key: "",
});

// temporary data
const dataCreateCustomer = () => ({
	nama: "",
	idoutlet: "",
	country_code: "62",
	telepon: "",
	jenis_kelamin: 0,
	tanggal_lahir: "",
	email: "",
	sapaan: "",
	agama: 0,
	instansi: "",
	alamat_customer: [],
})
const alamatTemp = () => ({
	idcustomer: "",
	idalamat: "",
	alamat: "",
	alamat_gmaps: "",
	latitude: 0,
	longitude: 0,
	judul: "",
	alamat_utama: [],
})

const scrollPosition = () => 0;

const state = {
	// data
	customer: customer(),
	detailCustomer: detailCustomer(),
	detailCustomer2: {},
	alamat: alamat(),
	topFive: topFive(),
	riwayat: riwayat(),

	// filter
	pagination: pagination(),
	paginationAlamat: paginationAlamat(),
	search: search(),
	searchAlamat: searchAlamat(),
	isSerachCustomer: false,
	isSearchAlamat: false,

	// temporary data
	dataCreateCustomer: dataCreateCustomer(),
	alamatTemp: alamatTemp(),

	scrollPosition: scrollPosition(),
}

export {
	state as default,
	customer,
	detailCustomer,
	alamat,
	topFive,
	riwayat,
	pagination,
	paginationAlamat,
	search,
	searchAlamat,
	dataCreateCustomer,
	alamatTemp,
	scrollPosition,
}